module.exports = __webpack_public_path__ + "static/media/p13.c61360cc.png";